import { styled } from '@material-ui/core';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
export default styled(BottomNavigationAction)({
    padding: '6px 12px 0 12px',
});
//# sourceMappingURL=index.js.map